export default "__VITE_PUBLIC_ASSET__e935bbf2__"